import { render, staticRenderFns } from "./TableController.vue?vue&type=template&id=3c021f50&scoped=true&"
import script from "./TableController.vue?vue&type=script&lang=js&"
export * from "./TableController.vue?vue&type=script&lang=js&"
import style0 from "./TableController.vue?vue&type=style&index=0&id=3c021f50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c021f50",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SortBySelector: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/results/TableController/components/SortBySelector.vue').default})
